import React, {  useRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import MobileDetect from 'mobile-detect';
// import "./show-more.scss";
const md = new MobileDetect(window.navigator.userAgent);

function UpArrow(props) {
    return (
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
     width="284.929px" height="284.929px" viewBox="0 0 284.929 284.929" 
     xmlSpace="preserve">
    <path d="M282.082,195.285L149.028,62.24c-1.901-1.903-4.088-2.856-6.562-2.856s-4.665,0.953-6.567,2.856L2.856,195.285
        C0.95,197.191,0,199.378,0,201.853c0,2.474,0.953,4.664,2.856,6.566l14.272,14.271c1.903,1.903,4.093,2.854,6.567,2.854
        c2.474,0,4.664-0.951,6.567-2.854l112.204-112.202l112.208,112.209c1.902,1.903,4.093,2.848,6.563,2.848
        c2.478,0,4.668-0.951,6.57-2.848l14.274-14.277c1.902-1.902,2.847-4.093,2.847-6.566
        C284.929,199.378,283.984,197.188,282.082,195.285z"/>

</svg>
    )
}

function DownArrow(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8">
            <path fill="#FFF" fillRule="evenodd" d="M6.772 6.05L.692-.03 0 .662 6.838 7.5l.692-.692-.069-.068L13.226.67l-.69-.69-5.764 6.07z"/>
        </svg>
    )
}

function ShowMoreButton(props) {
    const linkEl = useRef(null);
    if (md.mobile() == null) {
        return null;
    } else {
        const { isExpanded, onClick } = props;
        const handleClick = (e) => {
            e.preventDefault();
            onClick(linkEl.current);
        }
        const ArrowIcon = isExpanded ? UpArrow : DownArrow;
        let className = cx({
            "show-more-container": true,
            "is-expanded": isExpanded
        })
        const label = isExpanded ? "Show Less" : "Show More";
        return (
            <div className={className}>
                    <button ref={linkEl} onClick={handleClick}>
                        { label }
                    </button>
                    <button onClick={handleClick}>
                        <ArrowIcon />
                    </button>
                </div>
        )
    }
}

ShowMoreButton.propTypes = {
    isExpanded: PropTypes.bool,
    onClick: PropTypes.func
}

ShowMoreButton.defaultProps = {
    isExpanded: false,
    onClick: () => {}
}

export default ShowMoreButton;